<template>
    <div class="aba-produto select-modal">
        <alert-container :messages="msgs" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column">
                    <vss-select
                        ref="gradeSelect"
                        searchable
                        clearable
                        @search="carregarGradeList"
                        @input="carregarDadosGrade"
                        :options="gradeSelect"
                        v-model="gradeSelected"
                        :loading="gradeLoading"
                        title="grade-select"
                        :height="40"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="tooltip-vincular-grade"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-3" v-if="permissao.create && !integracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="promptChangeVinculo"
                        :disabled="gradeSelected == null || 
                            (gradeSelected !=null && idgradedefault == gradeSelected.id)
                        "
                    >
                        {{ $t("vincular-grade") }}
                    </button>
                </div>
                <div class="column is-3" v-if="permissaoGrade.create && !integracaoGrade">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        :disabled="!gradeSelected"
                        @click="$router.push({
                                name: 'ven-grade-edit',
                                params: { id: gradeSelected.id},
                                query: { 
                                    dadoscadastrais: 6,
                                    id: $route.params.id,
                                    politicacomercial: $route.query.politicacomercial 
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial 
                                        ? $route.query.analisecomercial
                                        : null
                                },
                            })
                        "
                    >
                        {{ $t("editar-grade") }}
                    </button>
                </div>
            </div>

            <empty-table-message
                v-if="!haveGrade"
                :msg="semColunas ? 'msg-grade-sem-colunas' : 'sem-resultados'"
            />
            <div v-if="haveGrade">
                <label v-text="$t('grade')" />
                <b-icon
                    icon="information"
                    size="is-small"
                    v-tippy 
                    :title="$t('aba-grade-info')"
                />
                <div class="content-overflow" >
                    <b-table v-if="!isLoading" 
                        :data="data" 
                        :bordered="true"
                        ref="gradeTable"
                        >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :width="f.width"
                            class="td-cell"
                            :sortable="f.sortable"
                        >
                            <template v-slot:header>

                                <!-- 84584 - COLUNA COM AS DESCRIÇÕES DAS LINHAS --> 
                                <div v-if="f.key == 'descricao'">
                                    <span>
                                        {{ $t("linha").toLocaleUpperCase() }}
                                    </span>
                                </div>

                                <!-- 84584 - COLUNA PADRÃO --> 
                                <div v-else-if="f.id >= 0">
                                    <div class="columns">
                                        <div class="column">
                                            <span>
                                                {{ f.key }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div v-else>
                                    <span>
                                        {{ f.key.toLocaleUpperCase() }}
                                    </span>
                                </div>

                            </template>

                            <template v-slot="props">

                                <!-- 84584 - LINHA PADRÃO --> 
                                <div v-if="f.key == 'descricao'">
                                    <div class="columns">
                                        <div class="column">
                                            <span>
                                                {{ props.row[f.key] }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div v-else-if="f.key == 'foto' && props.row['foto']" class="fotoColumn" >
                                    <div :style="{'background-image': 'url(\'' + props.row['foto'] + '\')'}" class="foto" alt=""/>
                                </div>

                                <div v-else>
                                    <div>
                                        <span>
                                            {{ props.row[f.key] }}
                                        </span>
                                    </div>
                                </div>
                            
                            </template>  

                        </b-table-column>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import GradeService from "@/services/vendas/GradeService";
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";
import Message from "@/models/Message";

export default {
    components: {
        Message,
    },
    data() {
        return {
            fields: [],
            data:[],
            idproduto: null,
            idgrade: null,
            idgradedefault: 0,
            service: new GradeService(this.$http, this.$router),
            produtoService: new VenProdutoService(this.$http, this.$router),
            integracao: this.$store.state.user.tabelasERPWebServer.includes("PRODUTO"),
            integracaoGrade: this.$store.state.user.tabelasERPWebServer.includes("GRADE"),
            permissao: false,
            permissaoGrade: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: true,
            column: "descricao",
            order: "asc",
            isSaving: false,
            grade: null,
            gradeSelect: [],
            gradeSelected: null,
            tabelaLiberada: false,
            haveGrade: false,
            loadingTabela: false,
            gradeLoading: false,
            semColunas: false,
            msgs: [],
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto-dados-cadastrais-grade"
        );

        this.permissaoGrade = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-grade'
        );

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "aba-grade" },
            });
        this.idproduto = this.$route.params.id;

        this.findGrade();
    },
    methods: {
        promptChangeVinculo() {
            let message = this.$t("msg-vincular-grade-nova");
            if(this.idgradedefault > 0){
                message = this.$t("msg-vincular-grade-existente")
            }
            this.$root.alert({
                message: message,
                onConfirm: this.saveGrade,
            });
        },
        saveGrade(){
            if(this.idgrade == null){
                return
            }
            this.isLoading = true;
            let tempProduto = {
                idproduto: this.idproduto,
                grade: {
                    idgrade: this.idgrade
                }
            }
            this.produtoService.saveGrade(tempProduto)
                .then((value) => {
                    if (value.message == null) {
                        let msg = this.$t('msg-save-sucesso-n', { n: this.$t('aba-grade') });
                        this.msgs.push(new Message("success", msg, true, false));
                        this.isLoading = false;
                        this.idgradedefault = this.idgrade;
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message("alert", value.message, true));
                        } else {
                            this.msgs.push(
                                new Message("error","msg-problema-realizar-acao",true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error("Erro ao salvar: " + e);
                    this.msgs.push(
                        new Message("error", "msg-erro-salvar", true)
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        findGrade(){
            this.isLoading = true;
            this.produtoService.loadGrade(this.idproduto)
                .then((value) => {
                    if(value){
                        this.idgrade = value.idgrade;
                        this.idgradedefault = value.idgrade;
                        this.gradeSelected = {
                            id: value.idgrade, 
                            label: value.descricao
                        }
                    } else{
                        this.idgrade = null;
                        this.carregarGradeList();
                    }
                })
                .catch(e => {
                    this.haveGrade = false;
                    this.loadingTabela = false;
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    if(this.idgrade == null) {
                        this.carregarGradeList();
                    }
                })
        },
        carregarGradeList(search = ".*"){
            this.gradeLoading = true;
            this.service
                .findAll('descricao', 'asc', 0, 1000, 3, search)
                .then(this.mapItems)
                .then((value) => {
                    this.gradeSelect = value;
                    this.isEmpty = this.gradeSelect.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar as gradeSelect.");
                })
                .finally((_) => {
                    this.gradeLoading = false;
                    if(this.idgrade > 0){
                        this.carregarDadosGrade();
                    }else{
                        this.isLoading = false;
                    }
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.idgrade,
                    label: m.descricao,
                };
            });
        },
        carregarDadosGrade(){
            if(!this.gradeSelected){
                this.idgrade = 0;
                this.haveGrade = false;
                return
            }
            this.haveGrade = true;
            this.semColunas = false;
            this.service.findByIdProduto(this.gradeSelected.id, this.idproduto,)
                .then(value => {
                    this.grade = value.content;
                    this.criaTabela();
                    this.criaData();
                })
                .catch(e => {
                    this.haveGrade = false;
                    this.isLoading = false;
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(_ => {
                    this.idgrade = this.gradeSelected.id;
                    this.isLoading = false;
                });
        },
        criaTabela(){
            this.fields = [];
            this.fields.push(
                {
                    id: -1,
                    key: "foto",
                    width: 150,
                    sortable: false,
                    sortFn: false
                },
                {
                    id: 0,
                    key: 'descricao',
                    width: 150,
                    sortable: false,
                    sortFn: false
                },
            )
            for(let e of this.grade.assGradeGradeColunas){
                this.fields.push({
                    key: e.gradeColuna.descricao,
                    width: 150,
                    sortable: false,
                    sortFn: false,
                    origem: 'coluna',
                    id: e.idgradecoluna,
                    idgrade: e.idgrade,
                    ordem: e.gradeColuna.ordem
                })
            }
            if(this.fields.length == 2) {
                this.semColunas = true;
                this.haveGrade = false;
            }
        },
        criaData(){
            this.data = [];
            for(let e of this.grade.assGradeGradeLinhas){

                let linha = {
                    descricao: e.gradeLinha.descricao,
                    origem: 'linha',
                    id: e.idgradelinha,
                    idgrade: e.idgrade,
                    ordem: e.gradeLinha.ordem,
                    foto: e.gradeLinha.url||null
                };

                this.data.push(linha)
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    .content-overflow{
        min-height: 100px;
        overflow-x: auto;
        white-space: nowrap;
        background-color: #f9f9f9;
        padding: 5px;
        border-radius: 6px;
    }

    .foto {
        width: 150px;
        height: 150px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .fotoColumn {
        display: flex;
        justify-content: center;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>